/**
 *
 */
export var AlignmentMode;
(function (AlignmentMode) {
    /**
     *
     */
    AlignmentMode[AlignmentMode["REGISTRATION_POINT"] = 0] = "REGISTRATION_POINT";
    /**
     *
     */
    AlignmentMode[AlignmentMode["TRANSFORM_POINT"] = 1] = "TRANSFORM_POINT";
})(AlignmentMode || (AlignmentMode = {}));
